import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import dayjs from 'dayjs';

import { DatePickerFrom } from 'components/_basic/Form/DatePicker/DatePickerFrom';
import { DatePickerTo } from 'components/_basic/Form/DatePicker/DatePickerTo';
import { RemoveButton } from 'components/_basic/Form/FieldArray/components/RemoveButton';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { Responsive } from 'components/_basic/Responsive';
import { ISectionRowProps as IProps } from 'components/BusinessToolForm';

import { concatWithDot } from 'helpers/string';

import { WORK_EXPERIENCE_NAMES } from '../../utils/form';

export const WorkExperience: FC<IProps> = memo(({ name, disabled = false, onRemove }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Grid container spacing={{ xs: '16px', md: '16px' }}>
      <Grid item xs={12} md={6}>
        <TextInputControl
          control={control}
          id={concatWithDot(name, WORK_EXPERIENCE_NAMES.EMPLOYER)}
          name={concatWithDot(name, WORK_EXPERIENCE_NAMES.EMPLOYER)}
          label={t('management.team.employer')}
          disabled={disabled}
          maxLength={150}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInputControl
          control={control}
          id={concatWithDot(name, WORK_EXPERIENCE_NAMES.POSITION)}
          name={concatWithDot(name, WORK_EXPERIENCE_NAMES.POSITION)}
          label={t('management.team.position')}
          disabled={disabled}
          maxLength={150}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DatePickerFrom
          control={control}
          id={concatWithDot(name, WORK_EXPERIENCE_NAMES.FROM)}
          name={concatWithDot(name, WORK_EXPERIENCE_NAMES.FROM)}
          fieldNameTo={concatWithDot(name, WORK_EXPERIENCE_NAMES.TO)}
          label={t('management.team.from')}
          disabled={disabled}
          maxDate={dayjs().subtract(1, 'day')}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DatePickerTo
          control={control}
          id={concatWithDot(name, WORK_EXPERIENCE_NAMES.TO)}
          name={concatWithDot(name, WORK_EXPERIENCE_NAMES.TO)}
          fieldNameFrom={concatWithDot(name, WORK_EXPERIENCE_NAMES.FROM)}
          label={t('management.team.to')}
          disabled={disabled}
          maxDate={dayjs()}
        />
      </Grid>
      <Grid item xs={12}>
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(name, WORK_EXPERIENCE_NAMES.FUNCTIONS)}
          name={concatWithDot(name, WORK_EXPERIENCE_NAMES.FUNCTIONS)}
          minRows={4}
          maxLength={500}
          label={t('management.team.functions')}
          disabled={disabled}
        />
      </Grid>
      <Responsive mobile>
        <Grid item xs={12}>
          <RemoveButton disabled={disabled} onClick={onRemove} canRemove>
            Delete
          </RemoveButton>
        </Grid>
      </Responsive>
    </Grid>
  );
});
